import React from 'react';
import { Form, Grid } from 'semantic-ui-react';
import { findTimeForReminder } from '../../../../HelperMethods/TaskUtilities';
import { lockIcon } from '../../../../HelperMethods/constants';

const TaskIndicatorComponent = React.memo(function TaskFormReminderComponent({ task }) {
  const reminder = findTimeForReminder(task);
  return (
    <>
      <Grid columns={2} style={{ margin: 0 }}>
        <Grid.Row>
          {task.isTaskLocked && (
            <Grid.Column>
              <Form.Field>
                <label>Task Lock</label>
                <div style={{ marginTop: '5px' }}>
                  <img
                    src={`data:image/svg+xml;charset=utf-8,${encodeURIComponent(lockIcon)}`}
                    className="tooltip-icon"
                    width="16px"
                  />
                </div>
              </Form.Field>
            </Grid.Column>
          )}
          {reminder && (
            <Grid.Column>
              <Form.Field>
                <label>Reminder</label>
                <div style={{ marginTop: '5px' }}>
                  <span className="reminder-indicator" /> {reminder}
                </div>
              </Form.Field>
            </Grid.Column>
          )}
        </Grid.Row>
      </Grid>
    </>
  );
});

export default TaskIndicatorComponent;
